import { getComparisonData, setComparisonData1, setComparisonInput1, setComparisonInput2, setComparisonInput3, setIsComparison } from "../../store/comparison/comparisonSlice";
import { useAppDispatch } from "../../store/hooks/StoreHooks";

const useComparisonFacade = () => {
    const dispatch = useAppDispatch();
    const updateIsComparison = (payload: boolean) => {
        return dispatch(setIsComparison(payload));
    };
    const updateComparisonData1 = (data: any) => {
        return dispatch(setComparisonData1(data));
    };

    const updateComparisonData2 = (data: any) => {
        return dispatch(setComparisonData1(data));
    };

    const updateComparisonData3 = (data: any) => {
        return dispatch(setComparisonData1(data));
    };
    const updateComparisonInput1 = (data: any) => {
        return dispatch(setComparisonInput1(data));
    };

    const updateComparisonInput2 = (data: any) => {
        return dispatch(setComparisonInput2(data));
    };

    const updateComparisonInput3 = (data: any) => {
        return dispatch(setComparisonInput3(data));
    };

    const loadComparisonData = () => {
        return dispatch(getComparisonData());
    }

    return {
        updateIsComparison,
        updateComparisonData1,
        updateComparisonData2,
        updateComparisonData3,
        updateComparisonInput1,
        updateComparisonInput2,
        updateComparisonInput3,
        loadComparisonData,
    };
};

export default useComparisonFacade;